import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const CARDS = [
  { key: "members", label: "Members", kind: "count" },
  { key: "monthlyRevenue", label: "Monthly revenue", kind: "money" },
  { key: "annualRevenue", label: "Annual revenue", kind: "money" },
  { key: "monthlyRedemptionCost", label: "Redemption cost / month", kind: "money" },
  { key: "annualRedemptionCost", label: "Annual redemption cost", kind: "money" },
  { key: "monthlyProfit", label: "Monthly profit", kind: "money" },
  { key: "annualProfit", label: "Annual profit", kind: "money" },
  { key: "profitLast30Days", label: "Profit last 30 days", kind: "money" },
  { key: "profitLast60Days", label: "Profit last 60 days", kind: "money" },
  { key: "redemptions", label: "Redemptions", kind: "count" },
];

function formatCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString();
}

function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString(undefined, { style: "currency", currency: "AUD" });
}

const MembershipAnalyticsSummary = ({ summary }) => {
  const totals = summary || {};
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "calc(100vw - 200px)",
        alignSelf: "flex-start",
        mx: "auto",
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
      }}
    >
      {CARDS.map((card) => (
        <Paper key={card.key} sx={{ px: 2, py: 1.25, minWidth: 150, flex: "1 1 150px" }} elevation={1}>
          <Typography variant="caption" color="text.secondary">
            {card.label}
          </Typography>
          <Typography variant="h6" component="p" data-testid={`summary-${card.key}`} sx={{ fontWeight: 600 }}>
            {card.kind === "money" ? formatMoney(totals[card.key]) : formatCount(totals[card.key])}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default MembershipAnalyticsSummary;
